import { Row } from "@tanstack/react-table";
import { getMatchingMetric, InstallationWithMetrics } from "@/metrics/installationMetrics";
import React from "react";
import formatValueAndUnit from "@/metrics/formatValueAndUnit";

export const MetricValueCell = ({ row, metricName }: { row: Row<InstallationWithMetrics>, metricName: string }) => {
  const metric = getMatchingMetric(row.original, metricName);
  if (!metric) {
    return (
      <div>-</div>
    )
  }

  const valueWrapper = (value: any) => (
    <span className="lg:text-lg" title={value.toString()} key={value}>
      {(Math.round(value * 10) / 10).toLocaleString()}
    </span>
  )
  const unitWrapper = (unit: any) => (
    <span className="mx-1 text-slate-400" key={unit}>
      {unit}
    </span>
  )

  const valueAndUnit = formatValueAndUnit(metric.value, metric.unit, valueWrapper, unitWrapper)

  return (
    <>
      {valueAndUnit}
    </>
  )
};
